export default __webpack_public_path__ + "2727d6a20184580ed89de7306f8fb32f.png";